var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.history.length > 0
    ? _c("section", { staticClass: "history pcOnly" }, [
        _c("div", { staticClass: "history__container" }, [
          _c("h2", { staticClass: "shopCommonInfo__title" }, [
            _vm._v("最近見たお店"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ui five cards" },
            _vm._l(_vm.shops, function (shop) {
              return _c(
                "a",
                {
                  key: shop.id,
                  staticClass: "ui card",
                  attrs: { href: shop.detail_url, target: "_blank" },
                },
                [
                  _c("div", { staticClass: "image" }, [
                    _c("img", {
                      attrs: {
                        src: shop.main_image.urls.medium_square,
                        alt: shop.name + "+宴会パーティ",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "header" }, [
                      _vm._v(_vm._s(shop.name)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "description" },
                      _vm._l(shop.genre_labels, function (genre) {
                        return _c("span", [_vm._v(_vm._s(genre.label))])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "extra" }, [
                      shop.max_standing_count || shop.max_count
                        ? _c("div", [
                            _vm._v(
                              "立席：" +
                                _vm._s(shop.max_standing_count || "--") +
                                "人 着席：" +
                                _vm._s(shop.max_count || "--") +
                                "人 まで"
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      shop.lowest_price
                        ? _c("div", [
                            _vm._v(_vm._s(shop.lowest_price) + "円〜"),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }